module.exports = __webpack_public_path__ + "img/profile-avatar.d7883e94.svg";